import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import {Link} from 'react-router-dom';

export const Container = styled.div`
  margin-top: 110px;
  margin-bottom: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;

export const H2Styled = styled.h2`
  font-family: Manrope, Helvetica, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 135%;
  text-align: center;
  color: #2C2B48;
  margin-bottom: 50px;
`;

export const Slide = styled.div`
  height: 350px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  @media screen and (min-width: 768px) {
    height: 590px;
  }
`

export const SlideCaption = styled.h6`
  font-size: 14px;
  line-height: 21px;
  font-weight: 500;
  text-transform: none;
  text-align: center;
  margin-bottom: 30px;
  @media screen and (min-width: 768px) {
    font-size: 22px;
    line-height: 40px;
  }
`

export const SlideImg = styled.img`
  max-height: 100%;
  max-width: 100%;
  
  &.small{
    max-height: 270px;
    max-width: 620px;
  }
`

export const SlideImgContainer = styled.div`
  display: inline-block;
  height: 475px;
  text-align: center;
  width: 100%;
`

export const Pagination = styled.div`
  display: flex;
  margin-top: 50px;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.colors.greyDark};
  margin-bottom: 45px;
`

export const PaginateButton = styled.div`
  height: 50px;
  width: 50px;
  background-color: ${props => props.theme.colors.primaryBlueLight};
  opacity: .8;
  margin: 0 10px;
  text-align: center;
  line-height: 46px;
`;

export const PaginateImg = styled.img`
  height: 15px;
`

export const StyledImg = styled.img`
  margin-bottom: 50px;
`;

export const StyledLink = styled(Link)`
  font-size: 14px;
  line-height: 16px;
  color: ${props => props.theme.colors.primaryBlueDark};
  font-weight: 700;
  text-decoration: underline;
  align-self: flex-start;
  
  @media screen and (min-width: 768px){
    font-size: 18px;
    line-height: 24px;
  }
`

export const StyledBtn = styled(Button)`
  border-radius: 8px ;
  font-family: Manrope, Helvetica, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 156%;
  letter-spacing: 0.01em;
  color: #3B3C3E;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 258px;
  height: 56px;
  margin: auto;
  position: relative;
  padding: 10px 2em;
  box-sizing: border-box;
  background-clip: padding-box; /* !importanté */
  border: solid 2px transparent; /* !importanté */
  &:before {
    content: '';
    position: absolute;
    top: 0; right: 0; bottom: 0; left: 0;
    z-index: -1;
    margin: -2px; /* !importanté */
    border-radius: inherit; /* !importanté */
    background: linear-gradient(45deg, rgba(28, 204, 239, 1) 0%, rgba(28, 98, 239, 1) 100%) ;
  }
  &:hover{
    background-color: #fff ;
    color: #3B3C3E;
    box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1) ;
    border: solid 2px transparent;
    border-color: transparent;
  }
  &:focus{
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    border: solid 2px transparent;
    border-color: transparent;
  }
  &:not(:disabled):not(.disabled):active{
    border: solid 2px transparent;
    border-color: transparent;
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    background-color: #fff ;
    color: #3B3C3E;
  }
`;